import {
  addCustomerDeliveryUser,
  deleteCustomer,
  fetchCustomerList,
  fetchDeliveryAppDomain,
  fetchDeliveryAppsInfo,
  fetchDeliveryAppStatus,



  getEnterpriseDeilveryAppsMonitoring,



  getEnterpriseDeliveryBindingDomains, getEnterpriseDeliveryDomains, getStoreDeilveryAppsMonitoring,



  getStoreDeliveryBindingDomains, getStoreDeliveryDomains, operationDeliveryApps,
  putReleaseApplication
} from '@/api/delivery';

const delivery = {
  state: {},

  mutations: {},

  actions: {
    // 查询交付详情
    GetDeliveryAppsInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppsInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 交付操作
    OperationDeliveryApps(_, resdata) {
      return new Promise((resolve, reject) => {
        operationDeliveryApps(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取域名（商店端）
    fetchStoreDeliveryDomains(_, resdata) {
      return new Promise((resolve, reject) => {
        getStoreDeliveryDomains(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取域名（企业端）
    fetchEnterpriseDeliveryDomains(_, resdata) {
      return new Promise((resolve, reject) => {
        getEnterpriseDeliveryDomains(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 绑定域名（商店端）
    fetchStoreDeliveryBindingDomains(_, resdata) {
      return new Promise((resolve, reject) => {
        getStoreDeliveryBindingDomains(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 绑定域名（企业端）
    fetchEnterpriseDeliveryBindingDomains(_, resdata) {
      return new Promise((resolve, reject) => {
        getEnterpriseDeliveryBindingDomains(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 交付应用监控数据（商店端）
    fetchStoreDeilveryAppsMonitoring(_, resdata) {
      return new Promise((resolve, reject) => {
        getStoreDeilveryAppsMonitoring(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 交付应用监控数据（企业端）
    fetchEnterpriseDeilveryAppsMonitoring(_, resdata) {
      return new Promise((resolve, reject) => {
        getEnterpriseDeilveryAppsMonitoring(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    // 交付操作
    PutReleaseApplication(_, resdata) {
      return new Promise((resolve, reject) => {
        putReleaseApplication(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询交付客户列表
    GetCustomerList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchCustomerList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 删除交付客户
    DeleteCustomer({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        deleteCustomer(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 添加交付客户应用列表
    AddCustomerDeliveryUser({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        addCustomerDeliveryUser(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 应用状态
    GetDeliveryAppStatus({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppStatus(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 应用基础信息
    GetDeliveryAppDomain({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchDeliveryAppDomain(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default delivery;



// WEBPACK FOOTER //
// ./src/store/modules/delivery.js